import { CrudStoreItemPartner360 } from 'legacy/lut/classes/models/partner360/CrudStoreItemPartner360'
import { IFormMPSTotalNew } from 'legacy/lut/classes/models/partner360/IFormMPSSummary'
import { appGetState } from 'legacy/lut/store'

import { downloadBlob } from 'clickNgo/helpers/common'
import { IPaging, IPagingFromTo } from 'core-components/types'
import { IDataProviderFilter, IFilter } from 'core-components/types'
import { getTokens } from 'core/classes/helpers/StorageHelper'
import { proxy } from 'core/classes/helpers/UrlHelper'
import { HttpHeaders, Rest } from 'core/classes/http'
import { CrudStore } from 'core/types/crudStore'
import Logger from 'core/utils/Logger'

export class MPSSummaryApi {
  public static fetchMPSDetails = async (
    filter: IDataProviderFilter,
    paging: IPaging | IPagingFromTo
  ) => {
    const yearFilter: IFilter | undefined = filter.filters.find(
      (el) => (el as IFilter).field === 'FYear'
    ) as IFilter | undefined
    const fieldFilter: IFilter | undefined = filter.filters.find(
      (el) => (el as IFilter).field === 'SelectBy'
    ) as IFilter | undefined
    const valueTypeFilter: IFilter | undefined = filter.filters.find(
      (el) => (el as IFilter).field === 'ValueType'
    ) as IFilter | undefined
    const contentFilter: IFilter | undefined = filter.filters.find(
      (el) => (el as IFilter).field === 'Content'
    ) as IFilter | undefined
    if (
      yearFilter &&
      yearFilter.value &&
      fieldFilter &&
      fieldFilter.value &&
      valueTypeFilter &&
      valueTypeFilter.value &&
      contentFilter &&
      contentFilter.value
    ) {
      const url = proxy(`/webservice/590/sp/v3/spJBPMPSTopPartnersDetails/call`)
      const payload = {
        'p.FYear': yearFilter.value,
        'p.NumOfPartners': paging['pageSize'] || paging['to'] || 1000,
        'p.SelectBy': fieldFilter.value,
        'p.ValueType': valueTypeFilter.value,
        'p.Content': contentFilter.value,
      }
      const marketFilter: IFilter | undefined = filter.filters.find(
        (el) => (el as IFilter).field === 'Market'
      ) as IFilter | undefined
      const countryFilter: IFilter | undefined = filter.filters.find(
        (el) => (el as IFilter).field === 'Country'
      ) as IFilter | undefined
      const pbmFilter: IFilter | undefined = filter.filters.find(
        (el) => (el as IFilter).field === 'PBM'
      ) as IFilter | undefined
      const partnerIdFilter: IFilter | undefined = filter.filters.find(
        (el) => (el as IFilter).field === 'PartnerId'
      ) as IFilter | undefined

      if (marketFilter && marketFilter.value) {
        payload['p.Market'] = marketFilter.value
      }
      if (countryFilter && countryFilter.value) {
        payload['p.Country'] = countryFilter.value
      }
      if (pbmFilter && pbmFilter.value) {
        payload['p.PBM'] = pbmFilter.value
      }
      if (partnerIdFilter && partnerIdFilter.value) {
        payload['p.PartnerId'] = partnerIdFilter.value
      }

      const { app } = appGetState()
      const [accessToken] = await getTokens(app.ownerId)

      const headers = new HttpHeaders()
      if (accessToken) {
        headers.add('Authorization', `Bearer ${accessToken}`)
      }
      const response = await Rest.post({ url, payload, headers })
      const rows = (response && response['Rows']) || []
      return { Data: rows }
    }
    return { Data: [] }
  }

  public static fetchMPSSummary = async (
    fyear: number,
    numOfPartners: number,
    field: string,
    actualsValueType: string,
    contentType: string,
    market?: string,
    country?: string,
    pbm?: string,
    partnerId?: string
  ) => {
    const url = proxy(`/webservice/590/sp/v3/spJBPMPSTopPartnersSummaryExpandable/call`)
    const payload = {
      'p.FYear': fyear,
      'p.NumOfPartners': numOfPartners,
      'p.SelectBy': field,
      'p.ValueType': actualsValueType,
      'p.Content': contentType,
    }
    if (market) {
      payload['p.Market'] = market
    }
    if (country) {
      payload['p.Country'] = country
    }
    if (pbm) {
      payload['p.PBM'] = pbm
    }
    if (partnerId) {
      payload['p.PartnerId'] = partnerId
    }

    const { app } = appGetState()
    const [accessToken] = await getTokens(app.ownerId)

    const headers = new HttpHeaders()
    if (accessToken) {
      headers.add('Authorization', `Bearer ${accessToken}`)
    }
    const response = await Rest.post({ url, payload, headers })
    const rows: IFormMPSTotalNew[] = (response && response['Rows']) || []
    return { Data: rows }
  }

  public static exportTopPartnersDetails = async (
    fyear: number,
    numOfPartners: number,
    field: string,
    actualsValueType: string,
    contentType: string,
    market?: string,
    country?: string,
    pbm?: string,
    partnerId?: string
  ) => {
    const url = proxy(`/webservice/590/sp/v3/spJBPMPSTopPartnersDetails/call/export`)
    const payload = {
      'p.FYear': fyear,
      'p.NumOfPartners': numOfPartners,
      'p.SelectBy': field,
      'p.ValueType': actualsValueType,
      'p.Content': contentType,
    }
    if (market) {
      payload['p.Market'] = market
    }
    if (country) {
      payload['p.Country'] = country
    }
    if (pbm) {
      payload['p.PBM'] = pbm
    }
    if (partnerId) {
      payload['p.PartnerId'] = partnerId
    }

    const { app } = appGetState()
    const [accessToken] = await getTokens(app.ownerId)

    const headers = new HttpHeaders()
    if (accessToken) {
      headers.add('Authorization', `Bearer ${accessToken}`)
    }
    const response = await Rest.post({ url, payload, headers })
    return response
  }

  public static exportTopPartnersDetailsTemplate = async (
    fyear: number,
    numOfPartners: number,
    field: string,
    actualsValueType: string,
    contentType: string,
    market?: string,
    country?: string
  ) => {
    const type = 'ExportMPSSummaryReportV2'
    const crudOptions = CrudStore.get(CrudStoreItemPartner360.JBPSettings)
    const options = await crudOptions.getById({ id: 1, keyField: 'EntryId' })
    if (options) {
      const url = proxy(`/form/data/export/by/template`)
      Logger.log(url)
      const data = new FormData()
      let mappings = []
      try {
        mappings = JSON.parse(options[type] || '')
      } catch (e) {}
      const filename = `mps top partner summary${country ? ' ' + country : ''}.xlsx`
      const keys = {}
      if (country) {
        keys['Country'] = country
      }
      if (market) {
        keys['Market'] = market
      }
      if (!market && !country) {
        keys['CreatedBy'] = '[spJBPMPSTopPartnersDetailsExport]'
      }
      data.append(
        'Mappings',
        JSON.stringify(
          mappings.map((mapping: { id: string }) => ({
            EntryId: parseInt(mapping.id, 10),
            Keys: keys,
          }))
        )
      )
      const { app } = appGetState()
      const token = (await getTokens(app.ownerId))[0]
      const res = await fetch(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        method: 'POST',
        body: data,
      })

      const blob = await res.blob()
      downloadBlob(filename, blob)
    }
  }
}
